import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { GiTargetPrize, GiHearts, GiTrophyCup, GiHighFive } from "react-icons/gi";
import PageBanner from "../../components/layout/PageBanner";
import SectionHeading from "../../components/common/SectionHeading";
import PlaceholderImage from "../../components/common/PlaceholderImage";
import "./About.css";

const TIMELINE = [
  { year: "Founding", text: "Firm Fit Factory opens its doors in Peelamedu, Coimbatore with a simple aim: coached, no-nonsense training." },
  { year: "Growth", text: "The member community grows around consistent programming and a supportive training floor." },
  { year: "Today", text: "A full range of programs — from strength to weight management — under one roof, coached by a dedicated team." },
];

const VALUES = [
  { icon: GiTargetPrize, title: "Purposeful Training", text: "Every session ties back to a goal — nothing is filler." },
  { icon: GiHearts, title: "Genuine Care", text: "Coaches who know your name, your history and your limits." },
  { icon: GiTrophyCup, title: "Consistency Over Hype", text: "Sustainable habits beat short-lived intensity." },
  { icon: GiHighFive, title: "Community First", text: "A floor where members push and support each other." },
];

export default function About() {
  return (
    <>
      <Helmet>
        <title>About Us | Firm Fit Factory Peelamedu, Coimbatore</title>
        <meta name="description" content="Learn about Firm Fit Factory's philosophy, mission and training approach at our Peelamedu, Coimbatore gym." />
        <link rel="canonical" href="https://www.firmfitfactory.com/about" />
      </Helmet>

      <PageBanner
        eyebrow="About Us"
        title="Built On Purpose"
        description="The story, philosophy and people behind Firm Fit Factory."
      />

      <section className="section about-intro">
        <div className="container about-intro__grid">
          {/* <PlaceholderImage tone="1" alt="Firm Fit Factory gym floor" ratio="4/3" /> */}
          <img src="/gymimages/gym13.png" alt="" />
          <div>
            <span className="eyebrow">Our Story</span>
            <h2>A gym built for people who train with purpose.</h2>
            <p>
              Firm Fit Factory is a modern fitness destination in Peelamedu, Coimbatore, created
              for people who want to become stronger, healthier and more confident. Our motivating
              environment, quality equipment and focused training experience help members stay
              committed to their goals.
            </p>
            <p>
              We keep our approach honest: programming based on real assessment, coaching that
              corrects form in the moment, and a schedule built around how our members actually train.
            </p>
          </div>
        </div>
      </section>

      <section className="section about-mission grid-texture-wrap">
        <div className="container about-mission__grid">
          <div className="about-mission__card">
            <span className="eyebrow">Mission</span>
            <h3>Make consistent, coached training accessible to every member who walks in.</h3>
          </div>
          <div className="about-mission__card">
            <span className="eyebrow">Vision</span>
            <h3>Become Coimbatore's most trusted name for real, measurable fitness results.</h3>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHeading eyebrow="Our Journey" title="Where we've" highlight="come from" />
          <div className="about-timeline">
            {TIMELINE.map((t) => (
              <div className="about-timeline__item" key={t.year}>
                <span className="about-timeline__year">{t.year}</span>
                <p>{t.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section about-values">
        <div className="container">
          <SectionHeading eyebrow="What We Stand For" title="Our" highlight="values" align="center" />
          <div className="about-values__grid">
            {VALUES.map((v) => {
              const Icon = v.icon;
              return (
                <div className="about-values__item" key={v.title}>
                  <Icon aria-hidden="true" />
                  <h3>{v.title}</h3>
                  <p>{v.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHeading eyebrow="Facilities" title="Inside the" highlight="factory" description="A clean, well-equipped training floor built for strength, functional and cardio work." />
          <div className="about-facilities">
            {["/gymimages/gym15.png",
              "/gymimages/gym1.png",
              "/gymimages/gym6.jpg",
              "/gymimages/gym8.jpg"].map((tone, i) => (
                // <PlaceholderImage tone={tone} alt="Firm Fit Factory facility" ratio="1/1" key={i} />
                <img src={tone} key={i} alt=" " />
              ))}
          </div>
        </div>
      </section>

      <section className="about-cta section">
        <div className="container about-cta__inner">
          <h2>Ready to train with purpose?</h2>
          <Link to="/contact" className="btn btn-primary">Join Now</Link>
        </div>
      </section>
    </>
  );
}
